module.exports = __webpack_public_path__ + "static/media/invoice-background.59a649c1.png";